// All user-facing words for the texting code prompt, in one place so they
// are easy to change. Rules: plain, warm, short, second person. Say only
// "enter the code": never mention a move, a provider, carriers, the
// registration behind it, or her number (Chris, 2026-09-27).

const SUPPORT_TEXT_NUMBER = '(317) 456-5610';

const TELNYX_MIGRATION_PIN_COPY = {
  title: 'Enter your texting code',
  body: (maskedPhone) => (maskedPhone
    ? `We texted a 6-digit code to your mobile phone ${maskedPhone}. Please enter it here to verify your phone.`
    : 'We texted a 6-digit code to your mobile phone. Please enter it here to verify your phone.'),
  fieldLabel: '6-digit code',
  verifyButton: 'Verify',
  verifyingButton: 'Checking…',
  success: "Thanks, you're all set. There's nothing else you need to do.",
  resendLink: 'Send a new code',
  resendSending: 'Sending…',
  resendSent: 'We sent you a new code.',
  // `wait` is already formatted ("45s", "2m 5s") by formatCooldown.
  resendCooldown: (wait) => `You can ask for a new code in ${wait}`,
  resendsLeft: (count) => (count === 1
    ? 'You can ask for 1 more code today.'
    : `You can ask for ${count} more codes today.`),
  resendNoneLeft: `You've asked for the most codes allowed today. Try again tomorrow, or text us at ${SUPPORT_TEXT_NUMBER}.`,
  help: "Didn't get it? Look for a text that starts with \"Connection Point:\", then ask for a new code if it isn't there.",
  genericError: 'Something went wrong. Please try again in a minute.',
  // Before the code is sent: the announcement links here, so this must not
  // say "nothing to do".
  pendingTitle: 'Your code is on its way',
  pendingBody: (maskedPhone) => (maskedPhone
    ? `In the next day or two we'll text a 6-digit code to your mobile phone ${maskedPhone}. Come back here and enter it when it arrives.`
    : "In the next day or two we'll text a 6-digit code to your mobile phone. Come back here and enter it when it arrives."),
  pendingWrongNumber: `If that isn't your mobile number, text us at ${SUPPORT_TEXT_NUMBER}.`,
  nothingToDo: 'Nothing to do here. Your texting is all set.',
  nothingToDoLink: 'Go to Connection Point',
  remindLater: 'Remind me later',
  pageTitle: 'Verify your phone',
};

export default TELNYX_MIGRATION_PIN_COPY;
